import React, { useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { Package, Wrench, Truck, Settings, LogOut, Menu, X, Zap, BookOpen, BarChart2, Archive } from 'lucide-react';

export default function Layout({ children }) {
  const { user, logout, hasPerm, isProducer, canAccessReports } = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const nav = [
    { to: '/orders',   icon: Package,  label: 'Заказы',    section: 'orders' },
    { to: '/repairs',  icon: Wrench,   label: 'Ремонт',    section: 'repairs' },
    { to: '/supplies', icon: Truck,    label: 'Поставки',  section: 'supplies' },
    ...(isProducer ? [{ to: '/catalog', icon: BookOpen, label: 'Справочник', section: null }] : []),
    ...(canAccessReports ? [{ to: '/reports', icon: BarChart2, label: 'Отчёты', section: null }] : []),
  ];

  const handleLogout = async () => { await logout(); navigate('/login'); };

  const Sidebar = () => (
    <aside className="w-56 flex flex-col bg-gray-950 border-r border-gray-800 h-full">
      <div className="flex items-center gap-2.5 px-4 py-4 border-b border-gray-800">
        <div className="w-7 h-7 bg-blue-600 rounded flex items-center justify-center">
          <Zap size={14} className="text-white" />
        </div>
        <span className="font-bold text-gray-100 tracking-tight">ТЕХСЕРВ B2B</span>
      </div>
      <nav className="flex-1 py-3 px-2 space-y-0.5">
        {nav.filter(n => !n.section || hasPerm(n.section, 'view')).map(n => (
          <NavLink key={n.to} to={n.to} onClick={() => setOpen(false)}
            className={({ isActive }) =>
              'flex items-center gap-3 px-3 py-2 rounded-md text-sm font-medium transition-colors ' +
              (isActive ? 'bg-blue-900/40 text-blue-300 border border-blue-800/50' : 'text-gray-400 hover:text-gray-200 hover:bg-gray-800')
            }>
            <n.icon size={16} />{n.label}
          </NavLink>
        ))}
      </nav>
      <div className="border-t border-gray-800 px-2 py-3 space-y-0.5">
        <NavLink to="/admin" onClick={() => setOpen(false)}
          className={({ isActive }) =>
            'flex items-center gap-3 px-3 py-2 rounded-md text-sm font-medium transition-colors ' +
            (isActive ? 'bg-gray-800 text-gray-200' : 'text-gray-500 hover:text-gray-300 hover:bg-gray-800')
          }>
          <Settings size={16} />{user?.role === 'dealer_user' ? 'Профиль и права' : 'Администрирование'}
        </NavLink>
        <button onClick={handleLogout}
          className="w-full flex items-center gap-3 px-3 py-2 rounded-md text-sm text-gray-500 hover:text-red-400 hover:bg-gray-800 transition-colors">
          <LogOut size={16} />Выйти
        </button>
      </div>
      <div className="px-4 py-3 border-t border-gray-800 bg-gray-900/50">
        <div className="text-xs font-medium text-gray-300 truncate">{user?.full_name}</div>
        <div className="text-xs text-gray-600 truncate">{user?.dealer_name || 'Производитель'}</div>
      </div>
    </aside>
  );

  return (
    <div className="flex h-screen overflow-hidden">
      <div className="hidden md:flex"><Sidebar /></div>
      {open && (
        <div className="fixed inset-0 z-40 md:hidden">
          <div className="absolute inset-0 bg-black/60" onClick={() => setOpen(false)} />
          <div className="absolute left-0 top-0 bottom-0 w-56 z-50"><Sidebar /></div>
        </div>
      )}
      <div className="flex-1 flex flex-col overflow-hidden">
        <header className="md:hidden flex items-center gap-3 px-4 py-3 border-b border-gray-800 bg-gray-950">
          <button onClick={() => setOpen(!open)} className="btn-ghost p-1">{open ? <X size={18} /> : <Menu size={18} />}</button>
          <span className="font-bold text-gray-100">ТЕХСЕРВ B2B</span>
        </header>
        <main className="flex-1 overflow-y-auto">{children}</main>
      </div>
    </div>
  );
}
